import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Flex, Loader } from '@mediahuis/chameleon-react';
import { ACTIVATION_SUCCESS, ACTIVATION_ERROR, ACTIVATION_NO_SUBSCRIPTION, ACTIVATION_NO_ACCESS, ACTIVATION_HAS_ACCESS, ACTIVATION_FORM, MULTIBRAND_ACTIVATION, MULTIBRAND_SUCCESS } from '../constants/steps';
import Act20 from '../Act20';
import Act30 from '../Act30';
import Act31 from '../Act31';
import Act32 from '../Act32';
import Act33 from '../Act33';
import Act34 from '../Act34';
import { goToUrl, noop } from '../utils';
import { checkSubscription, hasMultiBrandActivation } from '../utils/subscription-management-api';
import MultiBrandActivation from '../MultiBrandActivation';
import MultiBrandSuccess from '../MultiBrandSuccess';
import { SITE_URLS } from '../constants';
var Wrapper = styled.div.withConfig({
  displayName: "flow__Wrapper",
  componentId: "sc-1nrhxrs-0"
})(["margin:32px 10px;font-family:var(--font-family-system);*{box-sizing:border-box;}"]);
/**
 * @param authToken
 * @param user
 * @param track
 * @param {SRConfig} config
 * @return {JSX.Element}
 * @constructor
 */

export var ActivationWall = function ActivationWall(_ref) {
  var _ref$authToken = _ref.authToken,
      authToken = _ref$authToken === void 0 ? '' : _ref$authToken,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$track = _ref.track,
      track = _ref$track === void 0 ? noop : _ref$track,
      config = _ref.config;

  var _useState = useState(''),
      status = _useState[0],
      setStatus = _useState[1];

  var _useState2 = useState(''),
      customerNumber = _useState2[0],
      setCustomerNumber = _useState2[1];

  var _useState3 = useState({
    box: user.busNumber || '',
    city: user.city || '',
    countryCode: user.countryCode || '',
    houseNumber: user.houseNumber || '',
    street: user.street || '',
    postalCode: user.zipcode || user.zip || ''
  }),
      address = _useState3[0],
      setAddress = _useState3[1];

  var queryParams = new URLSearchParams(window.location.search);
  var redirectArticleBrand = queryParams.get('articleBrand');
  var redirectArticleId = queryParams.get('articleId');
  useEffect(function () {
    checkSubscription({
      authToken: authToken,
      accountGuid: user.accountId,
      config: config
    }).then(function (response) {
      if (hasMultiBrandActivation(response.subscription.type)) {
        setStatus(MULTIBRAND_ACTIVATION);
        return null;
      }

      if (response.subscription) {
        setStatus(ACTIVATION_SUCCESS);
        return null;
      }

      setStatus(ACTIVATION_FORM);
      return null;
    }).catch(function () {
      return setStatus(ACTIVATION_FORM);
    });
  }, [authToken, user, config]);

  var getActStep = function getActStep() {
    switch (status) {
      case ACTIVATION_FORM:
        return /*#__PURE__*/React.createElement("div", {
          id: "current-screen",
          "data-current-screen": ACTIVATION_FORM
        }, /*#__PURE__*/React.createElement(Act20, {
          user: user,
          track: track,
          address: address,
          setStatus: setStatus,
          setAddress: setAddress,
          customerNumber: customerNumber,
          setCustomerNumber: setCustomerNumber,
          config: config,
          authToken: authToken
        }));

      case ACTIVATION_SUCCESS:
        if (redirectArticleBrand && redirectArticleId) {
          var redirect = SITE_URLS.find(function (item) {
            return item.brand === redirectArticleBrand;
          });
          return goToUrl(redirect.url + "/cnt/" + redirectArticleId);
        }

        return /*#__PURE__*/React.createElement("div", {
          id: "current-screen",
          "data-current-screen": ACTIVATION_SUCCESS
        }, /*#__PURE__*/React.createElement(Act30, {
          user: user,
          track: track,
          config: config
        }));

      case ACTIVATION_NO_SUBSCRIPTION:
        return /*#__PURE__*/React.createElement("div", {
          id: "current-screen",
          "data-current-screen": ACTIVATION_NO_SUBSCRIPTION
        }, /*#__PURE__*/React.createElement(Act31, {
          user: user,
          track: track,
          setStatus: setStatus,
          config: config
        }));

      case ACTIVATION_NO_ACCESS:
        return /*#__PURE__*/React.createElement("div", {
          id: "current-screen",
          "data-current-screen": ACTIVATION_NO_ACCESS
        }, /*#__PURE__*/React.createElement(Act32, {
          user: user,
          track: track,
          config: config
        }));

      case ACTIVATION_HAS_ACCESS:
        return /*#__PURE__*/React.createElement("div", {
          id: "current-screen",
          "data-current-screen": ACTIVATION_HAS_ACCESS
        }, /*#__PURE__*/React.createElement(Act33, {
          user: user,
          track: track,
          config: config
        }));

      case ACTIVATION_ERROR:
        return /*#__PURE__*/React.createElement("div", {
          id: "current-screen",
          "data-current-screen": ACTIVATION_ERROR
        }, /*#__PURE__*/React.createElement(Act34, {
          user: user,
          track: track,
          config: config
        }));

      case MULTIBRAND_ACTIVATION:
        return /*#__PURE__*/React.createElement("div", {
          id: "current-screen",
          "data-current-screen": MULTIBRAND_ACTIVATION
        }, /*#__PURE__*/React.createElement(MultiBrandActivation, {
          user: user,
          track: track,
          config: config,
          authToken: authToken,
          setStatus: setStatus
        }));

      case MULTIBRAND_SUCCESS:
        if (redirectArticleBrand && redirectArticleId) {
          var _redirect = SITE_URLS.find(function (item) {
            return item.brand === redirectArticleBrand;
          });

          return goToUrl(_redirect.url + "/cnt/" + redirectArticleId);
        }

        return /*#__PURE__*/React.createElement("div", {
          id: "current-screen",
          "data-current-screen": MULTIBRAND_SUCCESS
        }, /*#__PURE__*/React.createElement(MultiBrandSuccess, {
          user: user,
          track: track,
          config: config
        }));
    }
  };

  if (status === '') {
    return /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      justifyContent: "center",
      style: {
        width: '100%',
        height: '100%'
      },
      my: 8
    }, /*#__PURE__*/React.createElement(Loader, null));
  }

  return /*#__PURE__*/React.createElement(Wrapper, null, getActStep(status));
};
export default ActivationWall;